import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { faChevronRight, faSliders, faTruck, faXmark } from '@fortawesome/free-solid-svg-icons';

export type LotRoomAction = 'move' | 'adjust';

export interface LotRoomActionData {
  lotNumber?: string;
}

/** Chooser for a room-dashboard lot row: move it or adjust its quantity. */
@Component({
  selector: 'lot-details-by-room-action',
  templateUrl: './lot-details-by-room-action.component.html',
  styleUrls: ['./lot-details-by-room-action.component.scss']
})
export class LotDetailsByRoomActionComponent {

  static open(dialog: MatDialog, data: LotRoomActionData): MatDialogRef<LotDetailsByRoomActionComponent, LotRoomAction> {
    return dialog.open(LotDetailsByRoomActionComponent, { data, width: '480px', maxWidth: '95vw' });
  }

  public faChevronRight = faChevronRight;
  public faSliders = faSliders;
  public faTruck = faTruck;
  public faXmark = faXmark;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LotRoomActionData,
    private dialogRef: MatDialogRef<LotDetailsByRoomActionComponent, LotRoomAction>
  ) { }

  close(action?: LotRoomAction) {
    this.dialogRef.close(action);
  }
}
